document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-nm-goal]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      
      var goal = btn.getAttribute('data-nm-goal');
      var map = {
        enfoque: '/collections/enfoque',
        memoria: '/collections/memoria',
        energia: '/collections/energia',
        sueno: '/collections/sueno',
        ansiedad: '/collections/ansiedad'
      };
      window.location.href = map[goal] || '/collections/all';
    });
  });

  document.querySelectorAll('[data-nm-bundle-discount]').forEach(function(el){
    var pct = el.getAttribute('data-nm-bundle-discount');
    if (pct && !el.querySelector('.nm-badge')) {
      var badge = document.createElement('span');
      badge.className = 'nm-badge';
      badge.innerText = '🔥 Ahorra ' + pct + '%';
      el.insertBefore(badge, el.firstChild);
    }
  });
});
